import { render } from "./baseButton.vue?vue&type=template&id=2f735d26&scoped=true"
import script from "./baseButton.vue?vue&type=script&lang=js"
export * from "./baseButton.vue?vue&type=script&lang=js"

import "./baseButton.vue?vue&type=style&index=0&id=2f735d26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f735d26"]])

export default __exports__